var map = {
	"./falken-in-the-running-again-at-the-international-motor-film-awards.webp": 6175,
	"./falken-tyres-a-proud-sponsor-of-the-supadrift.webp": 586,
	"./falken-tyres-receive-high-marks-in-wear-testing-performed-by-adac.webp": 3415,
	"./figure-2stamford-team-with-zein.jpg": 6090,
	"./figure-3-zanil-in-falkne-gear.jpg": 6056,
	"./figure-4-supadrift-series-champions.jpg": 6380,
	"./figure-5-stacey-lee-spinning-at-the-supadrift.jpg": 6618,
	"./newsroom-banner.webp": 845,
	"./place-on-the-winner’s-podium-for-the-falken-azenis-fk510-suv-in-the-big-autobild-allrad-summer-tyre-test-of-2022.webp": 1476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5811;